export enum DurationUnit {
  MINUTES = 'DURATION_MINUTES',
  HOURS = 'DURATION_HOURS',
  DAYS = 'DURATION_DAYS',
}
